/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Step_4Inputs */

const en_svc_rag_step_4 = /** @type {(inputs: Svc_Rag_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch with a review loop: missing or wrong answers are flagged and fixed at the source.`)
};

const lv_svc_rag_step_4 = /** @type {(inputs: Svc_Rag_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ieviešam ar pārskatīšanas ciklu: trūkstošas vai kļūdainas atbildes tiek atzīmētas un izlabotas avotā.`)
};

/**
* | output |
* | --- |
* | "Launch with a review loop: missing or wrong answers are flagged and fixed at the source." |
*
* @param {Svc_Rag_Step_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_step_4 = /** @type {((inputs?: Svc_Rag_Step_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Step_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_step_4(inputs)
	return en_svc_rag_step_4(inputs)
});